var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancelNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92144 9.15147C7.20793 9.15147 9.07286 7.29369 9.07286 5.00005C9.07286 2.70641 7.20793 0.848633 4.92144 0.848633C2.63494 0.848633 0.77002 2.71356 0.77002 5.00005C0.77002 7.28655 2.63494 9.15147 4.92144 9.15147ZM4.92144 1.43455C6.8864 1.43455 8.48694 3.03509 8.48694 5.00005C8.48694 6.96501 6.8864 8.56556 4.92144 8.56556C2.95648 8.56556 1.35593 6.96501 1.35593 5.00005C1.35593 3.03509 2.95648 1.43455 4.92144 1.43455Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36358 6.51494C3.42074 6.5721 3.49219 6.60068 3.57079 6.60068C3.64939 6.60068 3.72084 6.5721 3.778 6.51494L4.92125 5.37169L6.0645 6.51494C6.12166 6.5721 6.19311 6.60068 6.27171 6.60068C6.35031 6.60068 6.42176 6.5721 6.47893 6.51494C6.59325 6.40061 6.59325 6.21483 6.47893 6.10051L5.33568 4.95726L6.47893 3.81401C6.59325 3.69969 6.59325 3.51391 6.47893 3.39959C6.3646 3.28526 6.17882 3.28526 6.0645 3.39959L4.92125 4.54283L3.778 3.39959C3.66368 3.28526 3.4779 3.28526 3.36358 3.39959C3.24925 3.51391 3.24925 3.69969 3.36358 3.81401L4.50682 4.95726L3.36358 6.10051C3.24925 6.21483 3.24925 6.40061 3.36358 6.51494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelNew);
export default __webpack_public_path__ + "static/media/icon-cancel-new.35eb190f20a8b2d436b2cbb442af009a.svg";
export { ForwardRef as ReactComponent };